
import Avatar from "@/components/Avatar.vue";
import Btn from "@/components/Btn.vue";
import Card from "@/components/Card.vue";
import Modal from "@/components/Modal.vue";
import HandleCompanyRoleModal from "@/components/HandleCompanyRoleModal.vue";
import AddUserToCognitoModal from "@/components/AddUserToCognitoModal.vue";
import { checkUserRole, RoleCodes } from "@/utils/roles";
import { getReferentName } from "@/utils/user";
import gql from "graphql-tag";
import _ from "lodash";
import Vue from "vue";
import Component from "vue-class-component";
import { Mutation, State, Getter } from "vuex-class";
import { State as StateStore } from "../store";
import * as Api from "@/types/graphql";
import { isFiredOrResigned } from "@/utils/status";
import { Prop } from "vue-property-decorator";
import config from "@/utils/config";

@Component({
  components: {
    Card,
    Avatar,
    Btn,
    Modal,
    HandleCompanyRoleModal,
    AddUserToCognitoModal,
  },
})
export default class CompanyEmployeesTable extends Vue {
  @State((state: StateStore) => state.auth.user) user: Api.User;
  @State((state: StateStore) => state.data.companyEmployees) employees;
  @Getter getStatus: (code: string) => Api.UserStatus;
  @Mutation showSuccess;
  @Mutation showError;

  @Prop()
  company;

  @Prop({ default: false })
  showFired;

  loading = false;

  sendingEmailUser = null;
  showSendingEmailModal = null;
  sendingEmailSubject = "";
  sendingEmailText = "";

  showChangingRoleUserModal = null;
  changingRoleUser = null;
  changingRoleUserLoading = false;

  showAddCompanyEmployeeModal = null;

  showActivatingUserModal = null;
  activatingUser = null;

  headers = [
    {
      text: "Nome",
      align: "start",
      sortable: true,
      value: "name",
    },
    {
      text: `Referente ${config.companyName}`,
      align: "start",
      sortable: false,
      value: "referent",
    },
    {
      text: "Utenza",
      align: "start",
      sortable: false,
      value: "authentication_guid",
    },
    { text: "Azioni", value: "actions", sortable: false, filterable: false },
  ];

  selected = [];

  getEmployees() {
    if (this.showFired) {
      return this.employees.filter((user) => {
        return isFiredOrResigned(user.status.code);
      });
    } else {
      return this.employees.filter((user) => {
        return !isFiredOrResigned(user.status.code);
      });
    }
  }

  capitalize(text) {
    return _.capitalize(text);
  }

  hasReferentName(user) {
    return !_.isEmpty(getReferentName(user));
  }

  getReferentName(user) {
    if (this.hasReferentName(user)) {
      return getReferentName(user);
    }
    return "Nessun referente";
  }

  setSending(item) {
    if (_.isNil(item)) {
      this.selected = [];
    } else {
      this.selected = [item];
    }
    this.showSendingEmailModal = item;
  }

  setChangingRoleUser(user) {
    this.changingRoleUser = user;
    this.showChangingRoleUserModal = user;
  }

  setActivatingUser(user) {
    this.activatingUser = user;
    this.showActivatingUserModal = user;
  }

  getModalKey() {
    return Math.random();
  }

  async sendEmail() {
    this.loading = true;
    const res = await this.$apollo.mutate({
      mutation: gql`
        mutation sendEmailToUser(
          $guid: ID!
          $subject: String!
          $text: String!
        ) {
          sendEmailToUser(guid: $guid, subject: $subject, text: $text)
        }
      `,
      variables: {
        guid: this.selected[0].guid,
        subject: this.sendingEmailSubject,
        text: this.sendingEmailText,
      },
    });
    this.loading = false;
    this.setSending(null);
    if (res.data.sendEmailToUser) {
      this.showSuccess("Email inviata correttamente");
      this.sendingEmailSubject = "";
      this.sendingEmailText = "";
    } else {
      this.showError("Errore invio email");
    }
  }

  isAdmin() {
    return checkUserRole(this.user, [RoleCodes.ADMIN1, RoleCodes.ADMIN2]);
  }
}
